// NEEDS_PRESENTATION_LITE_CONDITION_EVIDENCE_V3
const conditionEvidence = {
  "capability:integrated_professional_identity_development": {
    "Outcome, accountability or control pressure": {
      "description": "Styrings- og resultatpress som kan forme hvilke profesjonelle handlinger, identiteter og prioriteringer som blir mulige.",
      "references": [
        {
          "root_id": "SR-0074",
          "harvard": "Dowling, F. (2006) ‘Physical education teacher educators' professional identities, continuing professional development and the issue of gender equality’. doi:10.1080/17408980600986306.",
          "url": "https://doi.org/10.1080/17408980600986306",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Today's neo-liberal, outcome-driven teacher education tends": {
      "description": "En kontekst der resultat- og styringslogikker kan forme profesjonell identitet og prioriteringer.",
      "references": [
        {
          "root_id": "SR-0074",
          "harvard": "Dowling, F. (2006) ‘Physical education teacher educators' professional identities, continuing professional development and the issue of gender equality’. doi:10.1080/17408980600986306.",
          "url": "https://doi.org/10.1080/17408980600986306",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "control / outcome / constraint orientation": {
      "description": "En orientering der kontroll, resultatkrav eller begrensninger får stor betydning for profesjonelt handlingsrom.",
      "references": [
        {
          "root_id": "SR-0074",
          "harvard": "Dowling, F. (2006) ‘Physical education teacher educators' professional identities, continuing professional development and the issue of gender equality’. doi:10.1080/17408980600986306.",
          "url": "https://doi.org/10.1080/17408980600986306",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    }
  },
  "capability:reciprocal_examination_of_professional_practice": {
    "Reciprocal trust and confidence": {
      "description": "Gjensidig tillit som gjør det sosialt mulig å eksponere usikkerhet, praksis og uferdige tanker for andre.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0054",
          "harvard": "Carrillo, C. & Flores, M.A. (2020) ‘COVID-19 and teacher education: a literature review of online teaching and learning practices’. doi:10.1080/02619768.2020.1821184.",
          "url": "https://doi.org/10.1080/02619768.2020.1821184",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0008",
          "harvard": "Kasneci, E. et al. (2023) ‘ChatGPT for good? On opportunities and challenges of large language models for education’. doi:10.1016/j.lindif.2023.102274.",
          "url": "https://doi.org/10.1016/j.lindif.2023.102274",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Open, collegial professional relationships": {
      "description": "Åpne kollegiale relasjoner som tåler spørsmål, uenighet og deling av praksis uten at dette oppleves som kontroll.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0075",
          "harvard": "Keay, J. (2006) ‘Collaborative learning in physical education teachers' early-career professional development’. doi:10.1080/17408980600986322.",
          "url": "https://doi.org/10.1080/17408980600986322",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0054",
          "harvard": "Carrillo, C. & Flores, M.A. (2020) ‘COVID-19 and teacher education: a literature review of online teaching and learning practices’. doi:10.1080/02619768.2020.1821184.",
          "url": "https://doi.org/10.1080/02619768.2020.1821184",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Peer collaboration and interaction": {
      "description": "Samarbeid mellom kolleger der praksis kan undersøkes, utfordres og utvikles sammen.",
      "references": [
        {
          "root_id": "SR-0054",
          "harvard": "Carrillo, C. & Flores, M.A. (2020) ‘COVID-19 and teacher education: a literature review of online teaching and learning practices’. doi:10.1080/02619768.2020.1821184.",
          "url": "https://doi.org/10.1080/02619768.2020.1821184",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0008",
          "harvard": "Kasneci, E. et al. (2023) ‘ChatGPT for good? On opportunities and challenges of large language models for education’. doi:10.1016/j.lindif.2023.102274.",
          "url": "https://doi.org/10.1016/j.lindif.2023.102274",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "social viability of professional exposure (trust, vulnerability, recognition or status)": {
      "description": "De sosiale kostnadene ved å vise praksis, usikkerhet eller behov — og om relasjonene gjør slik eksponering trygg nok.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0075",
          "harvard": "Keay, J. (2006) ‘Collaborative learning in physical education teachers' early-career professional development’. doi:10.1080/17408980600986322.",
          "url": "https://doi.org/10.1080/17408980600986322",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0054",
          "harvard": "Carrillo, C. & Flores, M.A. (2020) ‘COVID-19 and teacher education: a literature review of online teaching and learning practices’. doi:10.1080/02619768.2020.1821184.",
          "url": "https://doi.org/10.1080/02619768.2020.1821184",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Reflective dialogue around practice": {
      "description": "Samtaler der erfaring og praksis gjøres til gjenstand for refleksjon, spørsmål og ny forståelse.",
      "references": [
        {
          "root_id": "SR-0054",
          "harvard": "Carrillo, C. & Flores, M.A. (2020) ‘COVID-19 and teacher education: a literature review of online teaching and learning practices’. doi:10.1080/02619768.2020.1821184.",
          "url": "https://doi.org/10.1080/02619768.2020.1821184",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0008",
          "harvard": "Kasneci, E. et al. (2023) ‘ChatGPT for good? On opportunities and challenges of large language models for education’. doi:10.1016/j.lindif.2023.102274.",
          "url": "https://doi.org/10.1016/j.lindif.2023.102274",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Inquiry into professional practice": {
      "description": "Systematisk undersøkelse av egen eller felles praksis som grunnlag for læring og utvikling.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0075",
          "harvard": "Keay, J. (2006) ‘Collaborative learning in physical education teachers' early-career professional development’. doi:10.1080/17408980600986322.",
          "url": "https://doi.org/10.1080/17408980600986322",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0054",
          "harvard": "Carrillo, C. & Flores, M.A. (2020) ‘COVID-19 and teacher education: a literature review of online teaching and learning practices’. doi:10.1080/02619768.2020.1821184.",
          "url": "https://doi.org/10.1080/02619768.2020.1821184",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Professional learning connected to practice": {
      "description": "Profesjonell læring som er tett koblet til konkrete erfaringer, situasjoner og utfordringer i praksis.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0075",
          "harvard": "Keay, J. (2006) ‘Collaborative learning in physical education teachers' early-career professional development’. doi:10.1080/17408980600986322.",
          "url": "https://doi.org/10.1080/17408980600986322",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0054",
          "harvard": "Carrillo, C. & Flores, M.A. (2020) ‘COVID-19 and teacher education: a literature review of online teaching and learning practices’. doi:10.1080/02619768.2020.1821184.",
          "url": "https://doi.org/10.1080/02619768.2020.1821184",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "relational_safety: learning vulnerability": {
      "description": "Relasjonell trygghet for å kunne være lærende, uferdig og sårbar sammen med andre.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0054",
          "harvard": "Carrillo, C. & Flores, M.A. (2020) ‘COVID-19 and teacher education: a literature review of online teaching and learning practices’. doi:10.1080/02619768.2020.1821184.",
          "url": "https://doi.org/10.1080/02619768.2020.1821184",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0075",
          "harvard": "Keay, J. (2006) ‘Collaborative learning in physical education teachers' early-career professional development’. doi:10.1080/17408980600986322.",
          "url": "https://doi.org/10.1080/17408980600986322",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    }
  },
  "capability:sustained_professional_inquiry": {
    "Sufficient time and continuity for professional learning": {
      "description": "Nok tid og kontinuitet til at profesjonell læring kan bli mer enn enkeltstående tiltak.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0222",
          "harvard": "Lieberman, A. (1995) ‘Practices That Support Teacher Development’.",
          "url": "https://openalex.org/W2139033912",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0104",
          "harvard": "Armour, K. & Yelling, M. (2007) ‘Effective Professional Development for Physical Education Teachers: The Role of Informal, Collaborative Learning’. doi:10.1123/jtpe.26.2.177.",
          "url": "https://doi.org/10.1123/jtpe.26.2.177",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Structured professional-development support": {
      "description": "Struktur, rammer og støtte som gjør profesjonell utvikling mulig å holde ved like over tid.",
      "references": [
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0118",
          "harvard": "Bingimlas, K. (2009) ‘Barriers to the Successful Integration of ICT in Teaching and Learning Environments: A Review of the Literature’. doi:10.12973/ejmste/75275.",
          "url": "https://doi.org/10.12973/ejmste/75275",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0099",
          "harvard": "Caena, F. & Redecker, C. (2019) ‘Aligning teacher competence frameworks to 21st century challenges: The case for the European Digital Competence Framework for Educators ( Digcompedu)’. doi:10.1111/ejed.12345.",
          "url": "https://doi.org/10.1111/ejed.12345",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "agency: recipient positioning": {
      "description": "Om personen primært posisjoneres som mottaker, eller har reelt handlingsrom til å definere og forme egen læring.",
      "references": [
        {
          "root_id": "SR-0222",
          "harvard": "Lieberman, A. (1995) ‘Practices That Support Teacher Development’.",
          "url": "https://openalex.org/W2139033912",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "social viability of professional exposure (trust, vulnerability, recognition or status)": {
      "description": "De sosiale kostnadene ved å vise praksis, usikkerhet eller behov — og om relasjonene gjør slik eksponering trygg nok.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0222",
          "harvard": "Lieberman, A. (1995) ‘Practices That Support Teacher Development’.",
          "url": "https://openalex.org/W2139033912",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Inquiry into professional practice": {
      "description": "Systematisk undersøkelse av egen eller felles praksis som grunnlag for læring og utvikling.",
      "references": [
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0125",
          "harvard": "Lunenberg, M., Korthagen, F. & Zwart, R. (2011) ‘Self-Study Research and the Development of Teacher Educators' Professional Identities’. doi:10.2304/eerj.2011.10.3.407.",
          "url": "https://doi.org/10.2304/eerj.2011.10.3.407",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Insufficiently open or collegial professional relationships": {
      "description": "Relasjoner som er for lukkede eller lite kollegiale til å bære undersøkelse, deling og læring.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0104",
          "harvard": "Armour, K. & Yelling, M. (2007) ‘Effective Professional Development for Physical Education Teachers: The Role of Informal, Collaborative Learning’. doi:10.1123/jtpe.26.2.177.",
          "url": "https://doi.org/10.1123/jtpe.26.2.177",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Professional agency and self-direction": {
      "description": "Handlingsrom til å definere spørsmål, ta faglige valg og drive egen profesjonell utvikling.",
      "references": [
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Insufficient structured professional-development support": {
      "description": "Fravær eller svakhet i strukturer som ellers kunne støttet profesjonell utvikling over tid.",
      "references": [
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0118",
          "harvard": "Bingimlas, K. (2009) ‘Barriers to the Successful Integration of ICT in Teaching and Learning Environments: A Review of the Literature’. doi:10.12973/ejmste/75275.",
          "url": "https://doi.org/10.12973/ejmste/75275",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0099",
          "harvard": "Caena, F. & Redecker, C. (2019) ‘Aligning teacher competence frameworks to 21st century challenges: The case for the European Digital Competence Framework for Educators ( Digcompedu)’. doi:10.1111/ejed.12345.",
          "url": "https://doi.org/10.1111/ejed.12345",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "Against this backdrop, professional development or professional learning initiatives in which teacher educators work collegially and autonomously": {
      "description": "Kollegial og autonom profesjonell læring som kontrast til mer kontroll- eller resultatstyrte utviklingsformer.",
      "references": [
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0088",
          "harvard": "Lunenberg, M. et al. (2016) ‘Collaborative teacher educator professional development in Europe: different voices, one goal’. doi:10.1080/19415257.2016.1206032.",
          "url": "https://doi.org/10.1080/19415257.2016.1206032",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0222",
          "harvard": "Lieberman, A. (1995) ‘Practices That Support Teacher Development’.",
          "url": "https://openalex.org/W2139033912",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "the proposition's organizing premise": {
      "description": "En underliggende antakelse som organiserer hvordan situasjonen og mulighetene blir forstått.",
      "references": [
        {
          "root_id": "SR-0222",
          "harvard": "Lieberman, A. (1995) ‘Practices That Support Teacher Development’.",
          "url": "https://openalex.org/W2139033912",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    },
    "knowledge-transfer versus situated-inquiry framing": {
      "description": "Spenningen mellom å forstå læring som overføring av kunnskap og som situert, undersøkende praksis.",
      "references": [
        {
          "root_id": "SR-0137",
          "harvard": "Schnellert, L., Richardson, P. & Cherkowski, S. (2014) ‘Teacher Educator Professional Development as Reflexive Inquiry’. doi:10.36510/learnland.v8i1.683.",
          "url": "https://doi.org/10.36510/learnland.v8i1.683",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        },
        {
          "root_id": "SR-0047",
          "harvard": "Schuck, S., Aubusson, P. & Buchanan, J. (2008) ‘Enhancing teacher education practice through professional learning conversations’. doi:10.1080/02619760802000297.",
          "url": "https://doi.org/10.1080/02619760802000297",
          "match": "text",
          "depth": "atom_proposition_relation_and_source_passage"
        }
      ]
    }
  },
  "capability:access_learning_and_support": {
    "support": {
      "description": "Praktisk, faglig eller relasjonell støtte som gjør det mulig å komme inn i, bli værende i og bruke et lærings- eller støttetilbud.",
      "references": [
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0220",
          "harvard": "Bowser, D. & Race, K. (1991) ‘Orientation for Distance Education Students: What is it worth?’. ERIC EJ434721.",
          "url": "https://eric.ed.gov/?id=EJ434721",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0215",
          "harvard": "Webb, B.M. (1970) ‘Needs and Expectations: As Seen by Students in an Academic Up-Grading Programme’. ERIC ED056292.",
          "url": "https://eric.ed.gov/?id=ED056292",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "services": {
      "description": "Tilgjengelige tjenester og støttefunksjoner som kan møte praktiske, faglige eller sosiale behov.",
      "references": [
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "community": {
      "description": "Tilhørighet til et sosialt eller faglig fellesskap som kan gi kontakt, kontinuitet, deltakelse og gjensidig støtte.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "information": {
      "description": "Tilgang til forståelig, relevant og handlingsnær informasjon som gjør det lettere å orientere seg, velge og bruke støtte.",
      "references": [
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "family": {
      "description": "Familie eller foresatte som del av støtte-, overgangs- eller beslutningssituasjonen.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counselors": {
      "description": "Rådgiverroller som kan koble behov til støtte, informasjon og videre tjenester.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "healthcare": {
      "description": "Tilgang til helserelatert støtte når helse påvirker læring, deltakelse eller stabilitet.",
      "references": [
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "mental health": {
      "description": "Psykososiale og psykiske helseforhold som påvirker trygghet, deltakelse og tilgang til støtte.",
      "references": [
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "housing": {
      "description": "Boligsituasjon som en praktisk stabilitetsbetingelse rundt læring og deltakelse.",
      "references": [
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "financial": {
      "description": "Økonomiske forhold som kan åpne eller begrense tilgang, deltakelse og kontinuitet.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "health": {
      "description": "Helseforhold som inngår i muligheten til å delta, lære eller få relevant støtte.",
      "references": [
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "orientation": {
      "description": "Orientering og veiledning som gjør overganger, valg og nye systemer mer navigerbare.",
      "references": [
        {
          "root_id": "SR-0220",
          "harvard": "Bowser, D. & Race, K. (1991) ‘Orientation for Distance Education Students: What is it worth?’. ERIC EJ434721.",
          "url": "https://eric.ed.gov/?id=EJ434721",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counselor": {
      "description": "En rådgiverrolle som kan gjøre støtte, informasjon og veiledning tilgjengelig.",
      "references": [
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counseling": {
      "description": "Rådgivning som kan koble behov til relevante valg, støtte og tjenester.",
      "references": [
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "communication": {
      "description": "Muligheten til å utveksle mening, få respons og gjøre behov eller erfaringer forståelige for andre.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "feedback": {
      "description": "Tilbakemelding som gjør det mulig å forstå egen situasjon, justere handling og utvikle videre praksis.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "advisement": {
      "description": "Veiledning og råd som gjør valg, støtte og videre handling mer navigerbart.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "technology": {
      "description": "Tilgang til og hensiktsmessig bruk av teknologi som kan åpne eller begrense læring, støtte og deltakelse.",
      "references": [
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "time": {
      "description": "Tid som reell betingelse for deltakelse, læring, refleksjon, kontinuitet og utvikling.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "resources": {
      "description": "Tilgang til relevante ressurser som tid, materiell, kompetanse eller støttefunksjoner som gjør handling mulig.",
      "references": [
        {
          "root_id": "SR-0162",
          "harvard": "Ahmadi, R. & Hasani, M. (2018) ‘Capturing Student Voice on TEFL Syllabus Design: Agenticity of Pedagogical Dialogue Negotiation’. ERIC EJ1205975.",
          "url": "https://eric.ed.gov/?id=EJ1205975",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "resource": {
      "description": "En ressurs som gir praktisk eller faglig handlingsrom i den aktuelle situasjonen.",
      "references": [
        {
          "root_id": "SR-0162",
          "harvard": "Ahmadi, R. & Hasani, M. (2018) ‘Capturing Student Voice on TEFL Syllabus Design: Agenticity of Pedagogical Dialogue Negotiation’. ERIC EJ1205975.",
          "url": "https://eric.ed.gov/?id=EJ1205975",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "language": {
      "description": "Språklige forutsetninger som påvirker tilgang, meningsskaping, deltakelse og muligheten til å uttrykke behov.",
      "references": [
        {
          "root_id": "SR-0243",
          "harvard": "Salamanca Gonzalez, F.O. (2020) ‘Subjective Needs Analysis: A Vital Resource to Assess Language Teaching’. ERIC EJ1311185.",
          "url": "https://eric.ed.gov/?id=EJ1311185",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "languages": {
      "description": "Språklige forutsetninger og variasjon som påvirker tilgang, meningsskaping og deltakelse.",
      "references": [
        {
          "root_id": "SR-0243",
          "harvard": "Salamanca Gonzalez, F.O. (2020) ‘Subjective Needs Analysis: A Vital Resource to Assess Language Teaching’. ERIC EJ1311185.",
          "url": "https://eric.ed.gov/?id=EJ1311185",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "professional development": {
      "description": "Strukturert eller uformell profesjonell læring som utvikler praksis, dømmekraft og handlingsrom.",
      "references": [
        {
          "root_id": "SR-0228",
          "harvard": "Atman, B.Y. & Karasu, N. (2026) ‘Professional Development Needs of Preschool Teachers Regarding Inclusive Education in Türkiye’. ERIC EJ1495246.",
          "url": "https://eric.ed.gov/?id=EJ1495246",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "training": {
      "description": "Opplæring eller kompetanseutvikling som gir mennesker bedre forutsetninger for å handle i situasjonen.",
      "references": [
        {
          "root_id": "SR-0228",
          "harvard": "Atman, B.Y. & Karasu, N. (2026) ‘Professional Development Needs of Preschool Teachers Regarding Inclusive Education in Türkiye’. ERIC EJ1495246.",
          "url": "https://eric.ed.gov/?id=EJ1495246",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "access": {
      "description": "Muligheten til faktisk å komme inn i og bruke et tilbud, en læringssituasjon eller en støtteordning.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "relationships": {
      "description": "Kvaliteten og tilgjengeligheten i relasjonene rundt læring, deltakelse og støtte — særlig når tillit og gjensidighet er avgjørende.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "collaboration": {
      "description": "Samarbeid som gjør erfaringer, kunnskap og ansvar tilgjengelig for flere enn enkeltpersonen.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "advisers": {
      "description": "Tilgang til personer som kan veilede, oversette systemet og støtte valg.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "service": {
      "description": "En konkret støtte- eller tjenestefunksjon som kan gjøre hjelp tilgjengelig.",
      "references": [
        {
          "root_id": "SR-0271",
          "harvard": "Stroub, K., Yin, M. & Cigarroa Kennedy, C. (2021) ‘Wraparound Needs in HISD: Findings from the District's 2019 Needs Assessment Survey’. ERIC ED611190.",
          "url": "https://eric.ed.gov/?id=ED611190",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "trustful": {
      "description": "Tillit som gjør deltakelse, åpenhet og hjelp-søking sosialt mulig.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    }
  },
  "capability:belong_and_connect": {
    "community": {
      "description": "Tilhørighet til et sosialt eller faglig fellesskap som kan gi kontakt, kontinuitet, deltakelse og gjensidig støtte.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "support": {
      "description": "Praktisk, faglig eller relasjonell støtte som gjør det mulig å komme inn i, bli værende i og bruke et lærings- eller støttetilbud.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0215",
          "harvard": "Webb, B.M. (1970) ‘Needs and Expectations: As Seen by Students in an Academic Up-Grading Programme’. ERIC ED056292.",
          "url": "https://eric.ed.gov/?id=ED056292",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "relationships": {
      "description": "Kvaliteten og tilgjengeligheten i relasjonene rundt læring, deltakelse og støtte — særlig når tillit og gjensidighet er avgjørende.",
      "references": [
        {
          "root_id": "SR-0213",
          "harvard": "Apolonio, J.A. (2021) ‘Needs Analysis, Challenges, and Teaching Strategies in English Grammar Learning’. ERIC ED613630.",
          "url": "https://eric.ed.gov/?id=ED613630",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "family": {
      "description": "Familie eller foresatte som del av støtte-, overgangs- eller beslutningssituasjonen.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "training": {
      "description": "Opplæring eller kompetanseutvikling som gir mennesker bedre forutsetninger for å handle i situasjonen.",
      "references": [
        {
          "root_id": "SR-0228",
          "harvard": "Atman, B.Y. & Karasu, N. (2026) ‘Professional Development Needs of Preschool Teachers Regarding Inclusive Education in Türkiye’. ERIC EJ1495246.",
          "url": "https://eric.ed.gov/?id=EJ1495246",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "services": {
      "description": "Tilgjengelige tjenester og støttefunksjoner som kan møte praktiske, faglige eller sosiale behov.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0151",
          "harvard": "Graham, S.W. (1988) ‘Adult Learners in a Community College Environment: Examining Changes and Trends in Learning Patterns’. ERIC EJ373864.",
          "url": "https://eric.ed.gov/?id=EJ373864",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "information": {
      "description": "Tilgang til forståelig, relevant og handlingsnær informasjon som gjør det lettere å orientere seg, velge og bruke støtte.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "financial": {
      "description": "Økonomiske forhold som kan åpne eller begrense tilgang, deltakelse og kontinuitet.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "health": {
      "description": "Helseforhold som inngår i muligheten til å delta, lære eller få relevant støtte.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "supporting": {
      "description": "I denne kapabilitetsprofilen opptrer «supporting» som en betingelse som kan forme hva som blir mulig.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0215",
          "harvard": "Webb, B.M. (1970) ‘Needs and Expectations: As Seen by Students in an Academic Up-Grading Programme’. ERIC ED056292.",
          "url": "https://eric.ed.gov/?id=ED056292",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "resources": {
      "description": "Tilgang til relevante ressurser som tid, materiell, kompetanse eller støttefunksjoner som gjør handling mulig.",
      "references": [
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counselor": {
      "description": "En rådgiverrolle som kan gjøre støtte, informasjon og veiledning tilgjengelig.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counselors": {
      "description": "Rådgiverroller som kan koble behov til støtte, informasjon og videre tjenester.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "communication": {
      "description": "Muligheten til å utveksle mening, få respons og gjøre behov eller erfaringer forståelige for andre.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "language": {
      "description": "Språklige forutsetninger som påvirker tilgang, meningsskaping, deltakelse og muligheten til å uttrykke behov.",
      "references": [
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "relationship": {
      "description": "Kvaliteten i den konkrete relasjonen rundt læring, deltakelse eller støtte.",
      "references": [
        {
          "root_id": "SR-0213",
          "harvard": "Apolonio, J.A. (2021) ‘Needs Analysis, Challenges, and Teaching Strategies in English Grammar Learning’. ERIC ED613630.",
          "url": "https://eric.ed.gov/?id=ED613630",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "professional development": {
      "description": "Strukturert eller uformell profesjonell læring som utvikler praksis, dømmekraft og handlingsrom.",
      "references": [
        {
          "root_id": "SR-0228",
          "harvard": "Atman, B.Y. & Karasu, N. (2026) ‘Professional Development Needs of Preschool Teachers Regarding Inclusive Education in Türkiye’. ERIC EJ1495246.",
          "url": "https://eric.ed.gov/?id=EJ1495246",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "access": {
      "description": "Muligheten til faktisk å komme inn i og bruke et tilbud, en læringssituasjon eller en støtteordning.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0151",
          "harvard": "Graham, S.W. (1988) ‘Adult Learners in a Community College Environment: Examining Changes and Trends in Learning Patterns’. ERIC EJ373864.",
          "url": "https://eric.ed.gov/?id=EJ373864",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    }
  },
  "capability:communicate_and_make_meaning": {
    "language": {
      "description": "Språklige forutsetninger som påvirker tilgang, meningsskaping, deltakelse og muligheten til å uttrykke behov.",
      "references": [
        {
          "root_id": "SR-0243",
          "harvard": "Salamanca Gonzalez, F.O. (2020) ‘Subjective Needs Analysis: A Vital Resource to Assess Language Teaching’. ERIC EJ1311185.",
          "url": "https://eric.ed.gov/?id=EJ1311185",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0206",
          "harvard": "Hoang Oanh, D.T. (2007) ‘Meeting Students' Needs in Two EAP Programmes in Vietnam and New Zealand: A Comparative Study’. ERIC EJ803267.",
          "url": "https://eric.ed.gov/?id=EJ803267",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "communication": {
      "description": "Muligheten til å utveksle mening, få respons og gjøre behov eller erfaringer forståelige for andre.",
      "references": [
        {
          "root_id": "SR-0246",
          "harvard": "Manos, M.A. & Kasambira, K.P. (1998) ‘Teacher Preparation Programs and Nontraditional Students’. ERIC EJ572748.",
          "url": "https://eric.ed.gov/?id=EJ572748",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "technology": {
      "description": "Tilgang til og hensiktsmessig bruk av teknologi som kan åpne eller begrense læring, støtte og deltakelse.",
      "references": [
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0155",
          "harvard": "Eastmond, J.N.J. & Stoddard, C.G. (1986) ‘An Assessment of Learner Needs within the Framework of Technological Innovation in Utah’. ERIC ED291365.",
          "url": "https://eric.ed.gov/?id=ED291365",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "information": {
      "description": "Tilgang til forståelig, relevant og handlingsnær informasjon som gjør det lettere å orientere seg, velge og bruke støtte.",
      "references": [
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0143",
          "harvard": "Ghufron, M.A. et al. (2016) ‘A Model of Research Paper Writing Instructional Materials for Academic Writing Course: \"Needs & Documents Analysis and Model Design\"’. ERIC EJ1089888.",
          "url": "https://eric.ed.gov/?id=EJ1089888",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "time": {
      "description": "Tid som reell betingelse for deltakelse, læring, refleksjon, kontinuitet og utvikling.",
      "references": [
        {
          "root_id": "SR-0143",
          "harvard": "Ghufron, M.A. et al. (2016) ‘A Model of Research Paper Writing Instructional Materials for Academic Writing Course: \"Needs & Documents Analysis and Model Design\"’. ERIC EJ1089888.",
          "url": "https://eric.ed.gov/?id=EJ1089888",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "curriculum": {
      "description": "Hvordan læreplan, innhold og organisering av læring samsvarer med faktiske behov og ønskede muligheter.",
      "references": [
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0214",
          "harvard": "Alqunayeer, H.S. & Zamir, S. (2016) ‘Needs Analysis of Saudi EFL Female Students: A Case Study of Qassim University’. ERIC EJ1157570.",
          "url": "https://eric.ed.gov/?id=EJ1157570",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "communications": {
      "description": "Kommunikasjonsformer og kanaler som påvirker hvor lett informasjon og mening kan utveksles.",
      "references": [
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0246",
          "harvard": "Manos, M.A. & Kasambira, K.P. (1998) ‘Teacher Preparation Programs and Nontraditional Students’. ERIC EJ572748.",
          "url": "https://eric.ed.gov/?id=EJ572748",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "training": {
      "description": "Opplæring eller kompetanseutvikling som gir mennesker bedre forutsetninger for å handle i situasjonen.",
      "references": [
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "instructional": {
      "description": "Utforming av undervisning som påvirker hvor tilgjengelig og meningsfull læringen blir.",
      "references": [
        {
          "root_id": "SR-0143",
          "harvard": "Ghufron, M.A. et al. (2016) ‘A Model of Research Paper Writing Instructional Materials for Academic Writing Course: \"Needs & Documents Analysis and Model Design\"’. ERIC EJ1089888.",
          "url": "https://eric.ed.gov/?id=EJ1089888",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "resource": {
      "description": "En ressurs som gir praktisk eller faglig handlingsrom i den aktuelle situasjonen.",
      "references": [
        {
          "root_id": "SR-0143",
          "harvard": "Ghufron, M.A. et al. (2016) ‘A Model of Research Paper Writing Instructional Materials for Academic Writing Course: \"Needs & Documents Analysis and Model Design\"’. ERIC EJ1089888.",
          "url": "https://eric.ed.gov/?id=EJ1089888",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "languages": {
      "description": "Språklige forutsetninger og variasjon som påvirker tilgang, meningsskaping og deltakelse.",
      "references": [
        {
          "root_id": "SR-0243",
          "harvard": "Salamanca Gonzalez, F.O. (2020) ‘Subjective Needs Analysis: A Vital Resource to Assess Language Teaching’. ERIC EJ1311185.",
          "url": "https://eric.ed.gov/?id=EJ1311185",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0206",
          "harvard": "Hoang Oanh, D.T. (2007) ‘Meeting Students' Needs in Two EAP Programmes in Vietnam and New Zealand: A Comparative Study’. ERIC EJ803267.",
          "url": "https://eric.ed.gov/?id=EJ803267",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "professional development": {
      "description": "Strukturert eller uformell profesjonell læring som utvikler praksis, dømmekraft og handlingsrom.",
      "references": [
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "community": {
      "description": "Tilhørighet til et sosialt eller faglig fellesskap som kan gi kontakt, kontinuitet, deltakelse og gjensidig støtte.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "services": {
      "description": "Tilgjengelige tjenester og støttefunksjoner som kan møte praktiske, faglige eller sosiale behov.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "financial": {
      "description": "Økonomiske forhold som kan åpne eller begrense tilgang, deltakelse og kontinuitet.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "family": {
      "description": "Familie eller foresatte som del av støtte-, overgangs- eller beslutningssituasjonen.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "health": {
      "description": "Helseforhold som inngår i muligheten til å delta, lære eller få relevant støtte.",
      "references": [
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "support": {
      "description": "Praktisk, faglig eller relasjonell støtte som gjør det mulig å komme inn i, bli værende i og bruke et lærings- eller støttetilbud.",
      "references": [
        {
          "root_id": "SR-0215",
          "harvard": "Webb, B.M. (1970) ‘Needs and Expectations: As Seen by Students in an Academic Up-Grading Programme’. ERIC ED056292.",
          "url": "https://eric.ed.gov/?id=ED056292",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "feedback": {
      "description": "Tilbakemelding som gjør det mulig å forstå egen situasjon, justere handling og utvikle videre praksis.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "advisement": {
      "description": "Veiledning og råd som gjør valg, støtte og videre handling mer navigerbart.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "relationships": {
      "description": "Kvaliteten og tilgjengeligheten i relasjonene rundt læring, deltakelse og støtte — særlig når tillit og gjensidighet er avgjørende.",
      "references": [
        {
          "root_id": "SR-0213",
          "harvard": "Apolonio, J.A. (2021) ‘Needs Analysis, Challenges, and Teaching Strategies in English Grammar Learning’. ERIC ED613630.",
          "url": "https://eric.ed.gov/?id=ED613630",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "relationship": {
      "description": "Kvaliteten i den konkrete relasjonen rundt læring, deltakelse eller støtte.",
      "references": [
        {
          "root_id": "SR-0213",
          "harvard": "Apolonio, J.A. (2021) ‘Needs Analysis, Challenges, and Teaching Strategies in English Grammar Learning’. ERIC ED613630.",
          "url": "https://eric.ed.gov/?id=ED613630",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    }
  },
  "capability:contribute_through_work_and_community": {
    "time": {
      "description": "Tid som reell betingelse for deltakelse, læring, refleksjon, kontinuitet og utvikling.",
      "references": [
        {
          "root_id": "SR-0205",
          "harvard": "Miller, G.D. (1981) ‘Medical Student Needs Assessment and Student Affairs Programming’. ERIC EJ247322.",
          "url": "https://eric.ed.gov/?id=EJ247322",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "technology": {
      "description": "Tilgang til og hensiktsmessig bruk av teknologi som kan åpne eller begrense læring, støtte og deltakelse.",
      "references": [
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0155",
          "harvard": "Eastmond, J.N.J. & Stoddard, C.G. (1986) ‘An Assessment of Learner Needs within the Framework of Technological Innovation in Utah’. ERIC ED291365.",
          "url": "https://eric.ed.gov/?id=ED291365",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "language": {
      "description": "Språklige forutsetninger som påvirker tilgang, meningsskaping, deltakelse og muligheten til å uttrykke behov.",
      "references": [
        {
          "root_id": "SR-0206",
          "harvard": "Hoang Oanh, D.T. (2007) ‘Meeting Students' Needs in Two EAP Programmes in Vietnam and New Zealand: A Comparative Study’. ERIC EJ803267.",
          "url": "https://eric.ed.gov/?id=EJ803267",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "information": {
      "description": "Tilgang til forståelig, relevant og handlingsnær informasjon som gjør det lettere å orientere seg, velge og bruke støtte.",
      "references": [
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "communication": {
      "description": "Muligheten til å utveksle mening, få respons og gjøre behov eller erfaringer forståelige for andre.",
      "references": [
        {
          "root_id": "SR-0167",
          "harvard": "Bosuwon, T. & Woodrow, L. (2009) ‘Developing a Problem-Based Course Based on Needs Analysis to Enhance English Reading Ability of Thai Undergraduate Students’. ERIC EJ831771.",
          "url": "https://eric.ed.gov/?id=EJ831771",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "professional development": {
      "description": "Strukturert eller uformell profesjonell læring som utvikler praksis, dømmekraft og handlingsrom.",
      "references": [
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0255",
          "harvard": "Mayes, E., Black, R. & Finneran, R. (2021) ‘The Possibilities and Problematics of Student Voice for Teacher Professional Learning: Lessons from an Evaluation Study’. ERIC EJ1292719.",
          "url": "https://eric.ed.gov/?id=EJ1292719",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "collaboration": {
      "description": "Samarbeid som gjør erfaringer, kunnskap og ansvar tilgjengelig for flere enn enkeltpersonen.",
      "references": [
        {
          "root_id": "SR-0155",
          "harvard": "Eastmond, J.N.J. & Stoddard, C.G. (1986) ‘An Assessment of Learner Needs within the Framework of Technological Innovation in Utah’. ERIC ED291365.",
          "url": "https://eric.ed.gov/?id=ED291365",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0167",
          "harvard": "Bosuwon, T. & Woodrow, L. (2009) ‘Developing a Problem-Based Course Based on Needs Analysis to Enhance English Reading Ability of Thai Undergraduate Students’. ERIC EJ831771.",
          "url": "https://eric.ed.gov/?id=EJ831771",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "advisers": {
      "description": "Tilgang til personer som kan veilede, oversette systemet og støtte valg.",
      "references": [
        {
          "root_id": "SR-0155",
          "harvard": "Eastmond, J.N.J. & Stoddard, C.G. (1986) ‘An Assessment of Learner Needs within the Framework of Technological Innovation in Utah’. ERIC ED291365.",
          "url": "https://eric.ed.gov/?id=ED291365",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0167",
          "harvard": "Bosuwon, T. & Woodrow, L. (2009) ‘Developing a Problem-Based Course Based on Needs Analysis to Enhance English Reading Ability of Thai Undergraduate Students’. ERIC EJ831771.",
          "url": "https://eric.ed.gov/?id=EJ831771",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "service": {
      "description": "En konkret støtte- eller tjenestefunksjon som kan gjøre hjelp tilgjengelig.",
      "references": [
        {
          "root_id": "SR-0155",
          "harvard": "Eastmond, J.N.J. & Stoddard, C.G. (1986) ‘An Assessment of Learner Needs within the Framework of Technological Innovation in Utah’. ERIC ED291365.",
          "url": "https://eric.ed.gov/?id=ED291365",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0167",
          "harvard": "Bosuwon, T. & Woodrow, L. (2009) ‘Developing a Problem-Based Course Based on Needs Analysis to Enhance English Reading Ability of Thai Undergraduate Students’. ERIC EJ831771.",
          "url": "https://eric.ed.gov/?id=EJ831771",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "trustful": {
      "description": "Tillit som gjør deltakelse, åpenhet og hjelp-søking sosialt mulig.",
      "references": [
        {
          "root_id": "SR-0155",
          "harvard": "Eastmond, J.N.J. & Stoddard, C.G. (1986) ‘An Assessment of Learner Needs within the Framework of Technological Innovation in Utah’. ERIC ED291365.",
          "url": "https://eric.ed.gov/?id=ED291365",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0167",
          "harvard": "Bosuwon, T. & Woodrow, L. (2009) ‘Developing a Problem-Based Course Based on Needs Analysis to Enhance English Reading Ability of Thai Undergraduate Students’. ERIC EJ831771.",
          "url": "https://eric.ed.gov/?id=EJ831771",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "relationships": {
      "description": "Kvaliteten og tilgjengeligheten i relasjonene rundt læring, deltakelse og støtte — særlig når tillit og gjensidighet er avgjørende.",
      "references": [
        {
          "root_id": "SR-0155",
          "harvard": "Eastmond, J.N.J. & Stoddard, C.G. (1986) ‘An Assessment of Learner Needs within the Framework of Technological Innovation in Utah’. ERIC ED291365.",
          "url": "https://eric.ed.gov/?id=ED291365",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0167",
          "harvard": "Bosuwon, T. & Woodrow, L. (2009) ‘Developing a Problem-Based Course Based on Needs Analysis to Enhance English Reading Ability of Thai Undergraduate Students’. ERIC EJ831771.",
          "url": "https://eric.ed.gov/?id=EJ831771",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    }
  },
  "capability:develop_professional_practice": {
    "language": {
      "description": "Språklige forutsetninger som påvirker tilgang, meningsskaping, deltakelse og muligheten til å uttrykke behov.",
      "references": [
        {
          "root_id": "SR-0243",
          "harvard": "Salamanca Gonzalez, F.O. (2020) ‘Subjective Needs Analysis: A Vital Resource to Assess Language Teaching’. ERIC EJ1311185.",
          "url": "https://eric.ed.gov/?id=EJ1311185",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0206",
          "harvard": "Hoang Oanh, D.T. (2007) ‘Meeting Students' Needs in Two EAP Programmes in Vietnam and New Zealand: A Comparative Study’. ERIC EJ803267.",
          "url": "https://eric.ed.gov/?id=EJ803267",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "curriculum": {
      "description": "Hvordan læreplan, innhold og organisering av læring samsvarer med faktiske behov og ønskede muligheter.",
      "references": [
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0214",
          "harvard": "Alqunayeer, H.S. & Zamir, S. (2016) ‘Needs Analysis of Saudi EFL Female Students: A Case Study of Qassim University’. ERIC EJ1157570.",
          "url": "https://eric.ed.gov/?id=EJ1157570",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "communications": {
      "description": "Kommunikasjonsformer og kanaler som påvirker hvor lett informasjon og mening kan utveksles.",
      "references": [
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "training": {
      "description": "Opplæring eller kompetanseutvikling som gir mennesker bedre forutsetninger for å handle i situasjonen.",
      "references": [
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "resource": {
      "description": "En ressurs som gir praktisk eller faglig handlingsrom i den aktuelle situasjonen.",
      "references": [
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0190",
          "harvard": "Mohammed, S.A.H. (2016) ‘Investigating the Application of Needs Analysis on EAP Business Administration Materials’. ERIC EJ1095583.",
          "url": "https://eric.ed.gov/?id=EJ1095583",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "languages": {
      "description": "Språklige forutsetninger og variasjon som påvirker tilgang, meningsskaping og deltakelse.",
      "references": [
        {
          "root_id": "SR-0243",
          "harvard": "Salamanca Gonzalez, F.O. (2020) ‘Subjective Needs Analysis: A Vital Resource to Assess Language Teaching’. ERIC EJ1311185.",
          "url": "https://eric.ed.gov/?id=EJ1311185",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0206",
          "harvard": "Hoang Oanh, D.T. (2007) ‘Meeting Students' Needs in Two EAP Programmes in Vietnam and New Zealand: A Comparative Study’. ERIC EJ803267.",
          "url": "https://eric.ed.gov/?id=EJ803267",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "professional development": {
      "description": "Strukturert eller uformell profesjonell læring som utvikler praksis, dømmekraft og handlingsrom.",
      "references": [
        {
          "root_id": "SR-0156",
          "harvard": "Ünlü, N.A. & Öz, H. (2019) ‘An Assessment of the Perceived Professional Development Needs of Turkish as a Foreign Language Teachers’. ERIC EJ1220790.",
          "url": "https://eric.ed.gov/?id=EJ1220790",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0255",
          "harvard": "Mayes, E., Black, R. & Finneran, R. (2021) ‘The Possibilities and Problematics of Student Voice for Teacher Professional Learning: Lessons from an Evaluation Study’. ERIC EJ1292719.",
          "url": "https://eric.ed.gov/?id=EJ1292719",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    }
  },
  "capability:learn_and_develop_capability": {
    "community": {
      "description": "Tilhørighet til et sosialt eller faglig fellesskap som kan gi kontakt, kontinuitet, deltakelse og gjensidig støtte.",
      "references": [
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "services": {
      "description": "Tilgjengelige tjenester og støttefunksjoner som kan møte praktiske, faglige eller sosiale behov.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "information": {
      "description": "Tilgang til forståelig, relevant og handlingsnær informasjon som gjør det lettere å orientere seg, velge og bruke støtte.",
      "references": [
        {
          "root_id": "SR-0181",
          "harvard": "D'Arcy, C.J., Eastburn, D.M. & Bruce, B.C. (2009) ‘How Media Ecologies Can Address Diverse Student Needs’. ERIC EJ822982.",
          "url": "https://eric.ed.gov/?id=EJ822982",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "family": {
      "description": "Familie eller foresatte som del av støtte-, overgangs- eller beslutningssituasjonen.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "support": {
      "description": "Praktisk, faglig eller relasjonell støtte som gjør det mulig å komme inn i, bli værende i og bruke et lærings- eller støttetilbud.",
      "references": [
        {
          "root_id": "SR-0215",
          "harvard": "Webb, B.M. (1970) ‘Needs and Expectations: As Seen by Students in an Academic Up-Grading Programme’. ERIC ED056292.",
          "url": "https://eric.ed.gov/?id=ED056292",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "time": {
      "description": "Tid som reell betingelse for deltakelse, læring, refleksjon, kontinuitet og utvikling.",
      "references": [
        {
          "root_id": "SR-0205",
          "harvard": "Miller, G.D. (1981) ‘Medical Student Needs Assessment and Student Affairs Programming’. ERIC EJ247322.",
          "url": "https://eric.ed.gov/?id=EJ247322",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counselors": {
      "description": "Rådgiverroller som kan koble behov til støtte, informasjon og videre tjenester.",
      "references": [
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counselor": {
      "description": "En rådgiverrolle som kan gjøre støtte, informasjon og veiledning tilgjengelig.",
      "references": [
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counseling": {
      "description": "Rådgivning som kan koble behov til relevante valg, støtte og tjenester.",
      "references": [
        {
          "root_id": "SR-0160",
          "harvard": "VanZile-Tamsen, C. (2002) ‘Assessing and Promoting Self-Regulated Strategy Use’. ERIC EJ655137.",
          "url": "https://eric.ed.gov/?id=EJ655137",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "curriculum": {
      "description": "Hvordan læreplan, innhold og organisering av læring samsvarer med faktiske behov og ønskede muligheter.",
      "references": [
        {
          "root_id": "SR-0214",
          "harvard": "Alqunayeer, H.S. & Zamir, S. (2016) ‘Needs Analysis of Saudi EFL Female Students: A Case Study of Qassim University’. ERIC EJ1157570.",
          "url": "https://eric.ed.gov/?id=EJ1157570",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "communications": {
      "description": "Kommunikasjonsformer og kanaler som påvirker hvor lett informasjon og mening kan utveksles.",
      "references": [
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0167",
          "harvard": "Bosuwon, T. & Woodrow, L. (2009) ‘Developing a Problem-Based Course Based on Needs Analysis to Enhance English Reading Ability of Thai Undergraduate Students’. ERIC EJ831771.",
          "url": "https://eric.ed.gov/?id=EJ831771",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "training": {
      "description": "Opplæring eller kompetanseutvikling som gir mennesker bedre forutsetninger for å handle i situasjonen.",
      "references": [
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "instructional": {
      "description": "Utforming av undervisning som påvirker hvor tilgjengelig og meningsfull læringen blir.",
      "references": [
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "communication": {
      "description": "Muligheten til å utveksle mening, få respons og gjøre behov eller erfaringer forståelige for andre.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0167",
          "harvard": "Bosuwon, T. & Woodrow, L. (2009) ‘Developing a Problem-Based Course Based on Needs Analysis to Enhance English Reading Ability of Thai Undergraduate Students’. ERIC EJ831771.",
          "url": "https://eric.ed.gov/?id=EJ831771",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0238",
          "harvard": "Matthew, R.G.S. & Hughes, D.C. (1992) ‘Student Developed Curriculum--Recognising and Meeting Needs’. ERIC EJ536070.",
          "url": "https://eric.ed.gov/?id=EJ536070",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "feedback": {
      "description": "Tilbakemelding som gjør det mulig å forstå egen situasjon, justere handling og utvikle videre praksis.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "advisement": {
      "description": "Veiledning og råd som gjør valg, støtte og videre handling mer navigerbart.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "technology": {
      "description": "Tilgang til og hensiktsmessig bruk av teknologi som kan åpne eller begrense læring, støtte og deltakelse.",
      "references": [
        {
          "root_id": "SR-0264",
          "harvard": "Parette, P., Huer, M.B. & Hourcade, J.J. (2003) ‘Using Assistive Technology Focus Groups with Families across Cultures’. ERIC EJ789138.",
          "url": "https://eric.ed.gov/?id=EJ789138",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "language": {
      "description": "Språklige forutsetninger som påvirker tilgang, meningsskaping, deltakelse og muligheten til å uttrykke behov.",
      "references": [
        {
          "root_id": "SR-0168",
          "harvard": "Azhar, H.P.O. & Masyi'ah, A.N. (2023) ‘Developing ESP Learning Materials for Airport Ground Handling Services Students: A Needs Analysis’. ERIC EJ1413202.",
          "url": "https://eric.ed.gov/?id=EJ1413202",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "relationships": {
      "description": "Kvaliteten og tilgjengeligheten i relasjonene rundt læring, deltakelse og støtte — særlig når tillit og gjensidighet er avgjørende.",
      "references": [
        {
          "root_id": "SR-0213",
          "harvard": "Apolonio, J.A. (2021) ‘Needs Analysis, Challenges, and Teaching Strategies in English Grammar Learning’. ERIC ED613630.",
          "url": "https://eric.ed.gov/?id=ED613630",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "relationship": {
      "description": "Kvaliteten i den konkrete relasjonen rundt læring, deltakelse eller støtte.",
      "references": [
        {
          "root_id": "SR-0213",
          "harvard": "Apolonio, J.A. (2021) ‘Needs Analysis, Challenges, and Teaching Strategies in English Grammar Learning’. ERIC ED613630.",
          "url": "https://eric.ed.gov/?id=ED613630",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "collaboration": {
      "description": "Samarbeid som gjør erfaringer, kunnskap og ansvar tilgjengelig for flere enn enkeltpersonen.",
      "references": [
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "advisers": {
      "description": "Tilgang til personer som kan veilede, oversette systemet og støtte valg.",
      "references": [
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "service": {
      "description": "En konkret støtte- eller tjenestefunksjon som kan gjøre hjelp tilgjengelig.",
      "references": [
        {
          "root_id": "SR-0183",
          "harvard": "Furst-Bowe, J. & Dittmann, W. (2001) ‘Identifying the Needs of Adult Women in Distance Learning Programs’. ERIC EJ643450.",
          "url": "https://eric.ed.gov/?id=EJ643450",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "trustful": {
      "description": "Tillit som gjør deltakelse, åpenhet og hjelp-søking sosialt mulig.",
      "references": [
        {
          "root_id": "SR-0144",
          "harvard": "Huang, C. (2014) ‘A Needs Analysis for Chinese Language Teaching at a University in the United States’. ERIC EJ1122336.",
          "url": "https://eric.ed.gov/?id=EJ1122336",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0145",
          "harvard": "Silvester, J.M. (1976) ‘A Needs Assessment of Adult Basic Education Students at Lewis and Clark Community College. Human Renewal Services Demonstration Project (H-085) Interim Report. Revised copy (June, 1976)’. ERIC ED126357.",
          "url": "https://eric.ed.gov/?id=ED126357",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    }
  },
  "capability:navigate_transitions_and_choices": {
    "support": {
      "description": "Praktisk, faglig eller relasjonell støtte som gjør det mulig å komme inn i, bli værende i og bruke et lærings- eller støttetilbud.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0220",
          "harvard": "Bowser, D. & Race, K. (1991) ‘Orientation for Distance Education Students: What is it worth?’. ERIC EJ434721.",
          "url": "https://eric.ed.gov/?id=EJ434721",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "time": {
      "description": "Tid som reell betingelse for deltakelse, læring, refleksjon, kontinuitet og utvikling.",
      "references": [
        {
          "root_id": "SR-0251",
          "harvard": "Reynolds, K.A. (2005) ‘The Fourth Grade Experience: Insights toward the Transition to Middle School’. ERIC ED491409.",
          "url": "https://eric.ed.gov/?id=ED491409",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0205",
          "harvard": "Miller, G.D. (1981) ‘Medical Student Needs Assessment and Student Affairs Programming’. ERIC EJ247322.",
          "url": "https://eric.ed.gov/?id=EJ247322",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "community": {
      "description": "Tilhørighet til et sosialt eller faglig fellesskap som kan gi kontakt, kontinuitet, deltakelse og gjensidig støtte.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "resources": {
      "description": "Tilgang til relevante ressurser som tid, materiell, kompetanse eller støttefunksjoner som gjør handling mulig.",
      "references": [
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0162",
          "harvard": "Ahmadi, R. & Hasani, M. (2018) ‘Capturing Student Voice on TEFL Syllabus Design: Agenticity of Pedagogical Dialogue Negotiation’. ERIC EJ1205975.",
          "url": "https://eric.ed.gov/?id=EJ1205975",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "relationships": {
      "description": "Kvaliteten og tilgjengeligheten i relasjonene rundt læring, deltakelse og støtte — særlig når tillit og gjensidighet er avgjørende.",
      "references": [
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "orientation": {
      "description": "Orientering og veiledning som gjør overganger, valg og nye systemer mer navigerbare.",
      "references": [
        {
          "root_id": "SR-0220",
          "harvard": "Bowser, D. & Race, K. (1991) ‘Orientation for Distance Education Students: What is it worth?’. ERIC EJ434721.",
          "url": "https://eric.ed.gov/?id=EJ434721",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0251",
          "harvard": "Reynolds, K.A. (2005) ‘The Fourth Grade Experience: Insights toward the Transition to Middle School’. ERIC ED491409.",
          "url": "https://eric.ed.gov/?id=ED491409",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "information": {
      "description": "Tilgang til forståelig, relevant og handlingsnær informasjon som gjør det lettere å orientere seg, velge og bruke støtte.",
      "references": [
        {
          "root_id": "SR-0251",
          "harvard": "Reynolds, K.A. (2005) ‘The Fourth Grade Experience: Insights toward the Transition to Middle School’. ERIC ED491409.",
          "url": "https://eric.ed.gov/?id=ED491409",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "supporting": {
      "description": "I denne kapabilitetsprofilen opptrer «supporting» som en betingelse som kan forme hva som blir mulig.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0220",
          "harvard": "Bowser, D. & Race, K. (1991) ‘Orientation for Distance Education Students: What is it worth?’. ERIC EJ434721.",
          "url": "https://eric.ed.gov/?id=EJ434721",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "family": {
      "description": "Familie eller foresatte som del av støtte-, overgangs- eller beslutningssituasjonen.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "language": {
      "description": "Språklige forutsetninger som påvirker tilgang, meningsskaping, deltakelse og muligheten til å uttrykke behov.",
      "references": [
        {
          "root_id": "SR-0168",
          "harvard": "Azhar, H.P.O. & Masyi'ah, A.N. (2023) ‘Developing ESP Learning Materials for Airport Ground Handling Services Students: A Needs Analysis’. ERIC EJ1413202.",
          "url": "https://eric.ed.gov/?id=EJ1413202",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "training": {
      "description": "Opplæring eller kompetanseutvikling som gir mennesker bedre forutsetninger for å handle i situasjonen.",
      "references": [
        {
          "root_id": "SR-0228",
          "harvard": "Atman, B.Y. & Karasu, N. (2026) ‘Professional Development Needs of Preschool Teachers Regarding Inclusive Education in Türkiye’. ERIC EJ1495246.",
          "url": "https://eric.ed.gov/?id=EJ1495246",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0149",
          "harvard": "Oliver, R. et al. (2013) ‘A Task-Based Needs Analysis for Australian Aboriginal Students: Going beyond the Target Situation to Address Cultural Issues’. ERIC EJ1089653.",
          "url": "https://eric.ed.gov/?id=EJ1089653",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "services": {
      "description": "Tilgjengelige tjenester og støttefunksjoner som kan møte praktiske, faglige eller sosiale behov.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0162",
          "harvard": "Ahmadi, R. & Hasani, M. (2018) ‘Capturing Student Voice on TEFL Syllabus Design: Agenticity of Pedagogical Dialogue Negotiation’. ERIC EJ1205975.",
          "url": "https://eric.ed.gov/?id=EJ1205975",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    }
  },
  "capability:participate_and_exercise_voice": {
    "support": {
      "description": "Praktisk, faglig eller relasjonell støtte som gjør det mulig å komme inn i, bli værende i og bruke et lærings- eller støttetilbud.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0218",
          "harvard": "Brandt, R. (1988) ‘On Students' Needs and Team Learning: A Conversation with William Glasser’. ERIC EJ370222.",
          "url": "https://eric.ed.gov/?id=EJ370222",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "community": {
      "description": "Tilhørighet til et sosialt eller faglig fellesskap som kan gi kontakt, kontinuitet, deltakelse og gjensidig støtte.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "resources": {
      "description": "Tilgang til relevante ressurser som tid, materiell, kompetanse eller støttefunksjoner som gjør handling mulig.",
      "references": [
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0162",
          "harvard": "Ahmadi, R. & Hasani, M. (2018) ‘Capturing Student Voice on TEFL Syllabus Design: Agenticity of Pedagogical Dialogue Negotiation’. ERIC EJ1205975.",
          "url": "https://eric.ed.gov/?id=EJ1205975",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "relationships": {
      "description": "Kvaliteten og tilgjengeligheten i relasjonene rundt læring, deltakelse og støtte — særlig når tillit og gjensidighet er avgjørende.",
      "references": [
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "supporting": {
      "description": "I denne kapabilitetsprofilen opptrer «supporting» som en betingelse som kan forme hva som blir mulig.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "family": {
      "description": "Familie eller foresatte som del av støtte-, overgangs- eller beslutningssituasjonen.",
      "references": [
        {
          "root_id": "SR-0236",
          "harvard": "Rous, B., Myers, C.T. & Stricklin, S.B. (2007) ‘Strategies for Supporting Transitions of Young Children with Special Needs and Their Families’. ERIC EJ804228.",
          "url": "https://eric.ed.gov/?id=EJ804228",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counselor": {
      "description": "En rådgiverrolle som kan gjøre støtte, informasjon og veiledning tilgjengelig.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "counselors": {
      "description": "Rådgiverroller som kan koble behov til støtte, informasjon og videre tjenester.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "communication": {
      "description": "Muligheten til å utveksle mening, få respons og gjøre behov eller erfaringer forståelige for andre.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "professional development": {
      "description": "Strukturert eller uformell profesjonell læring som utvikler praksis, dømmekraft og handlingsrom.",
      "references": [
        {
          "root_id": "SR-0228",
          "harvard": "Atman, B.Y. & Karasu, N. (2026) ‘Professional Development Needs of Preschool Teachers Regarding Inclusive Education in Türkiye’. ERIC EJ1495246.",
          "url": "https://eric.ed.gov/?id=EJ1495246",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        },
        {
          "root_id": "SR-0255",
          "harvard": "Mayes, E., Black, R. & Finneran, R. (2021) ‘The Possibilities and Problematics of Student Voice for Teacher Professional Learning: Lessons from an Evaluation Study’. ERIC EJ1292719.",
          "url": "https://eric.ed.gov/?id=EJ1292719",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "training": {
      "description": "Opplæring eller kompetanseutvikling som gir mennesker bedre forutsetninger for å handle i situasjonen.",
      "references": [
        {
          "root_id": "SR-0228",
          "harvard": "Atman, B.Y. & Karasu, N. (2026) ‘Professional Development Needs of Preschool Teachers Regarding Inclusive Education in Türkiye’. ERIC EJ1495246.",
          "url": "https://eric.ed.gov/?id=EJ1495246",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "access": {
      "description": "Muligheten til faktisk å komme inn i og bruke et tilbud, en læringssituasjon eller en støtteordning.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0162",
          "harvard": "Ahmadi, R. & Hasani, M. (2018) ‘Capturing Student Voice on TEFL Syllabus Design: Agenticity of Pedagogical Dialogue Negotiation’. ERIC EJ1205975.",
          "url": "https://eric.ed.gov/?id=EJ1205975",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "technology": {
      "description": "Tilgang til og hensiktsmessig bruk av teknologi som kan åpne eller begrense læring, støtte og deltakelse.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "text",
          "depth": "v21_structure_excerpt_only"
        }
      ]
    },
    "information": {
      "description": "Tilgang til forståelig, relevant og handlingsnær informasjon som gjør det lettere å orientere seg, velge og bruke støtte.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0162",
          "harvard": "Ahmadi, R. & Hasani, M. (2018) ‘Capturing Student Voice on TEFL Syllabus Design: Agenticity of Pedagogical Dialogue Negotiation’. ERIC EJ1205975.",
          "url": "https://eric.ed.gov/?id=EJ1205975",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    },
    "services": {
      "description": "Tilgjengelige tjenester og støttefunksjoner som kan møte praktiske, faglige eller sosiale behov.",
      "references": [
        {
          "root_id": "SR-0152",
          "harvard": "Hipolito-Delgado, C.P. et al. (2021) ‘Advocating for Students during Distance Learning: The Role of the School Counselor’. ERIC EJ1362167.",
          "url": "https://eric.ed.gov/?id=EJ1362167",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0162",
          "harvard": "Ahmadi, R. & Hasani, M. (2018) ‘Capturing Student Voice on TEFL Syllabus Design: Agenticity of Pedagogical Dialogue Negotiation’. ERIC EJ1205975.",
          "url": "https://eric.ed.gov/?id=EJ1205975",
          "match": "profile",
          "depth": "profile_route"
        },
        {
          "root_id": "SR-0179",
          "harvard": "Ahmadi, R. & Yousofi, N. (2024) ‘Hearing Student Voice within the Context of Iran: Building Schools for the Future’. ERIC EJ1451747.",
          "url": "https://eric.ed.gov/?id=EJ1451747",
          "match": "profile",
          "depth": "profile_route"
        }
      ]
    }
  }
};

export default conditionEvidence;
